<div class="dental-referral-form">
  <div class="formHeader">
    <div class="logoContainer">
      <img src="../../assets/new-co-logo-lg.png" alt="CareOregon Logo" class="logo" />
    </div>
    <div class="formTitle">
      Request For Dental Service
    </div>
    <button mat-icon-button matTooltip="Close and Logout" class="close-button" (click)="onLogoutClick()" aria-label="Close and Logout">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <hr />

  <div class="formContainer">
    <ng-container *ngIf="!isFormSubmitted; else confirmationBlock">
      <form *ngIf="formReady" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="content">

          <!-- Today's Date -->
          <b>Today's Date: {{ todaysDate }}</b>

          <!-- Urgent or Non-Urgent -->
          <div>
            <mat-radio-group formControlName="urgentRequest">
              <mat-radio-button value="Non-Urgent">Non-Urgent/Routine*</mat-radio-button>
              <mat-radio-button value="Urgent">Urgent (pain, managed infection or swelling)*</mat-radio-button>
            </mat-radio-group>
          </div>

          <span class="important-text">
            For dental emergencies (unusual swelling or infection of the face/gums, tooth avulsion) <b>Providers</b> may call Dental Care Coordination at 503-488-7665 Monday thru Friday 8am to 5pm PST.
          </span>

          <!-- Patient Lookup -->
          <div class="display-box" formGroupName="patientLookup">
            <span class="title">Patient Search</span>

            <mat-form-field appearance="outline">
              <mat-label>Medicaid ID</mat-label>
              <input matInput formControlName="medicaidId" required autocomplete="nope" aria-autocomplete="none" />
              <button class="icon-button" type="button" matSuffix mat-icon-button aria-label="MemberSearch" (click)="getMemberData()">
                <i matSuffix class="fa-solid fa-user-magnifying-glass"></i>
              </button>
              <mat-error *ngIf="form.get('patientLookup.medicaidId')?.invalid && form.get('patientLookup.medicaidId')?.touched">
                Medicaid ID must be exactly 8 characters long.
              </mat-error>
            </mat-form-field>

            <!-- Display the search message outside of mat-error to make sure it is always visible -->
            <div *ngIf="memberSearchMessage.length > 0" class="error-message">
              {{ memberSearchMessage }}
            </div>
          </div>

          <!-- Patient Information -->
          <div class="display-box" formGroupName="patient">
            <span class="title">Patient Information</span>

            <mat-form-field appearance="outline">
              <mat-label>Patient First Name</mat-label>
              <input matInput formControlName="firstName" required autocomplete="nope" aria-autocomplete="none" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Patient Last Name</mat-label>
              <input matInput formControlName="lastName" required autocomplete="nope" aria-autocomplete="none" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>DOB (MM/DD/YYYY)</mat-label>
              <input matInput
                     formControlName="dob"
                     [matDatepicker]="picker"
                     [max]="today"
                     [matDatepickerFilter]="dateFilter"
                     required
                     autocomplete="off"
                     aria-autocomplete="none" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="form.get('patient.dob')?.touched && form.get('patient.dob')?.invalid">
                <ng-container *ngIf="form.get('patient.dob')?.hasError('required')">
                  This field is required.
                </ng-container>
                <ng-container *ngIf="form.get('patient.dob')?.hasError('matDatepickerMax')">
                  DOB cannot be in the future.
                </ng-container>
                <ng-container *ngIf="form.get('patient.dob')?.hasError('futureDateNotAllowed')">
                  Future dates are not allowed.
                </ng-container>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Patient Phone</mat-label>
              <input matInput
                     formControlName="phone"
                     mask="000-000-0000"
                     autocomplete="off" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Parent/Guardian, if minor</mat-label>
              <input matInput formControlName="parentGuardian" autocomplete="nope" aria-autocomplete="none" />
            </mat-form-field>

            <div class="split-radio-group">
              <div>Is the patient aware you are submitting this request on their behalf?*</div>
              <mat-radio-group formControlName="awareOfRequest">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
              </mat-radio-group>
            </div>


          </div>

          <!-- Provider Information -->
          <div class="display-box" formGroupName="provider">
            <span class="title">Referring Provider Information</span>

            <mat-form-field appearance="outline">
              <mat-label>Clinic/Program Name</mat-label>
              <input matInput formControlName="clinic" required autocomplete="nope" aria-autocomplete="none" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Clinic NPI</mat-label>
              <input matInput formControlName="clinicNPI" autocomplete="nope" aria-autocomplete="none" mask="0000000000" />
              <mat-error *ngIf="form.get('provider.clinicNPI')?.invalid && form.get('provider.clinicNPI')?.touched">
                <ng-container *ngIf="form.get('provider.clinicNPI')?.hasError('required')">
                  Clinic NPI is required.
                </ng-container>
                <ng-container *ngIf="form.get('provider.clinicNPI')?.hasError('pattern')">
                  NPI must be exactly 10 digits.
                </ng-container>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Provider Name</mat-label>
              <input matInput formControlName="providerName" autocomplete="nope" aria-autocomplete="none" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Phone Number</mat-label>
              <input matInput
                     formControlName="phoneNumber"
                     mask="000-000-0000"
                     required
                     autocomplete="off"
                     aria-autocomplete="none" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Fax for Correspondence</mat-label>
              <input matInput
                     formControlName="fax"
                     mask="000-000-0000"
                     autocomplete="off"
                     aria-autocomplete="none" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Email for Correspondence</mat-label>
              <input matInput
                     formControlName="email"
                     type="email"
                     required
                     autocomplete="off"
                     aria-autocomplete="none" />

              <mat-error *ngIf="form.get('provider.email')?.touched && form.get('provider.email')?.invalid">
                <ng-container *ngIf="form.get('provider.email')?.hasError('required')">
                  Email is required.
                </ng-container>
                <ng-container *ngIf="form.get('provider.email')?.hasError('email')">
                  Invalid email format.
                </ng-container>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Person submitting this form</mat-label>
              <input matInput formControlName="submitterName" required autocomplete="nope" aria-autocomplete="none" />
            </mat-form-field>
          </div>

          <!-- Clinical Presentation -->
          <div class="display-box left-justify" formGroupName="clinicalPresentation">
            <span class="title">Clinical Presentation</span>

            <mat-checkbox formControlName="dentalCaries">Dental caries/Dental decay</mat-checkbox>
            <mat-checkbox formControlName="swellingAbscess">Swelling/Abscess</mat-checkbox>
            <mat-checkbox formControlName="oralPathology">Oral Pathology</mat-checkbox>
            <mat-checkbox formControlName="pain">Pain</mat-checkbox>
            <mat-checkbox formControlName="otherClinicalPresentation">Other</mat-checkbox>
            <mat-form-field appearance="outline">
              <mat-label>Other presentation details</mat-label>
              <input matInput
                     formControlName="otherClinicalPresentationDescription"
                     autocomplete="off" />
            </mat-form-field>
          </div>

          <!-- Health Conditions -->
          <div class="display-box left-justify" formGroupName="healthConditions">
            <span class="title">Health Conditions</span>

            <mat-checkbox formControlName="pregnancy">Pregnancy</mat-checkbox>
            <mat-checkbox formControlName="diabetes">Diabetes</mat-checkbox>
            <mat-checkbox formControlName="cardiovascularDisease">Cardiovascular Disease</mat-checkbox>
            <mat-checkbox formControlName="otherMedicalConditions">Other significant medical conditions</mat-checkbox>
            <mat-form-field appearance="outline">
              <mat-label>Other health conditions</mat-label>
              <input matInput
                     formControlName="otherMedicalConditionsDescription"
                     autocomplete="off"
                     aria-autocomplete="none" />
            </mat-form-field>
          </div>

          <!-- Comments -->
          <div class="display-box">
            <span class="title">Comments About the Condition</span>
            <mat-form-field appearance="outline" class="comments">
              <textarea matInput formControlName="comments" autocomplete="nope" aria-autocomplete="none"></textarea>
            </mat-form-field>
          </div>

          <!-- Submit -->
          <button class="submit-button" mat-raised-button color="primary" [disabled]="form.invalid">Submit</button>
        </div>
      </form>
    </ng-container>
    <ng-template #confirmationBlock>
      <div class="confirmation-message">
        <h2>Your referral has been submitted.</h2>
        <p>What would you like to do next?</p>
        <div class="confirmation-buttons">
          <button mat-raised-button color="primary" (click)="startNewForm()">Start a New Form</button>
          <button mat-raised-button color="accent" (click)="onLogoutClick()">Logout</button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
